import React from 'react';
import { Project } from '../../../types';
import { ProjectIcon } from '../../../components/layout/Sidebar';

interface CompilationViewProps {
  project: Project;
  objective: string;
  compilationStage: number;
}

export const CompilationView: React.FC<CompilationViewProps> = ({ project, objective, compilationStage }) => (
  <div className="flex-1 flex flex-col items-center justify-start h-full pt-24 md:pt-32 px-6 bg-white dark:bg-[#050505]">
    {/* Header card shrinking animation */}
    <div className="w-full max-w-3xl animate-in slide-in-from-bottom-8 fade-in duration-700">
      <div className="flex items-start gap-4 mb-16 p-6 rounded-2xl border border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-[#111112] shadow-sm">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-white dark:bg-[#1a1a1a] border border-gray-200 dark:border-gray-800 shadow-sm shrink-0">
          <ProjectIcon name={project.icon} className="w-6 h-6 text-zinc-900 dark:text-white" />
        </div>
        <div className="flex-1">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white font-sans">{project.name}</h2>
          <p className="text-sm font-semibold text-gray-600 dark:text-gray-400 mt-2 leading-relaxed">{objective}</p>
        </div>
      </div>

      {/* Blueprint Visualizer Pipeline */}
      <div className="space-y-8 pl-5 border-l-2 border-gray-100 dark:border-gray-850 ml-6 relative">
        
        <div className="relative">
          <div className={`absolute -left-[23px] top-1 w-3.5 h-3.5 rounded-full border-[3px] ${compilationStage >= 0 ? 'border-blue-500 bg-white dark:bg-black' : 'border-gray-200 dark:border-gray-800 bg-white dark:bg-black'}`} />
          <div className={`transition-all duration-700 ${compilationStage >= 0 ? 'opacity-100' : 'opacity-0 translate-y-2'}`}>
            <div className="flex items-center gap-3">
              <span className="text-base font-bold text-gray-900 dark:text-white font-sans">Parsing objective...</span>
              {compilationStage === 0 && <span className="w-4 h-4 border-[3px] border-gray-200 dark:border-gray-800 border-t-blue-500 dark:border-t-blue-400 rounded-full animate-spin" />}
            </div>
          </div>
        </div>

        <div className="relative">
          <div className={`absolute -left-[23px] top-1 w-3.5 h-3.5 rounded-full border-[3px] ${compilationStage >= 1 ? 'border-purple-500 bg-white dark:bg-black' : 'border-gray-200 dark:border-gray-800 bg-white dark:bg-black'}`} />
          <div className={`transition-all duration-700 ${compilationStage >= 1 ? 'opacity-100' : 'opacity-0 translate-y-2'}`}>
            <div className="flex items-center gap-3">
              <span className="text-base font-bold text-gray-900 dark:text-white font-sans">Mapping operational phases...</span>
              {compilationStage === 1 && <span className="w-4 h-4 border-[3px] border-gray-200 dark:border-gray-800 border-t-purple-500 dark:border-t-purple-400 rounded-full animate-spin" />}
            </div>
          </div>
        </div>

        <div className="relative">
          <div className={`absolute -left-[23px] top-1 w-3.5 h-3.5 rounded-full border-[3px] ${compilationStage >= 2 ? 'border-green-500 bg-white dark:bg-black' : 'border-gray-200 dark:border-gray-800 bg-white dark:bg-black'}`} />
          <div className={`transition-all duration-700 ${compilationStage >= 2 ? 'opacity-100' : 'opacity-0 translate-y-2'}`}>
            <div className="flex items-center gap-3">
              <span className="text-base font-bold text-gray-900 dark:text-white font-sans">Injecting tool permissions...</span>
              {compilationStage === 2 && <span className="w-4 h-4 border-[3px] border-gray-200 dark:border-gray-800 border-t-green-500 dark:border-t-green-400 rounded-full animate-spin" />}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
);
